module.exports = __webpack_public_path__ + "static/image/logo-family/new_logo_bmart.ver2_0_2.png?25ad4846";